import { BACKUP_JOBS } from '@/shared/features/jobs/jobs.constants';
import { TInvalidateJobTagsParams } from '@/shared/hooks/use-invalidate-job-tags/use-invalidate-job-tags.types';
import { devicesApi } from '@/shared/redux/api/assets/devices/devices-api';
import { jobsApi } from '@/shared/redux/api/jobs/jobs-api';
import { useAppDispatch } from '@/shared/redux/hooks/hooks';

export const useInvalidateJobTags = () => {
  const dispatch = useAppDispatch();

  const invalidateJobTags = ({
    eventType,
    payload,
  }: TInvalidateJobTagsParams) => {
    const _eventType = eventType.toLowerCase();

    if (
      _eventType.includes('jobcreated') ||
      _eventType.includes('jobdeleted')
    ) {
      dispatch(jobsApi.util.invalidateTags([{ type: 'Job', id: 'LIST' }]));
    }

    if (
      _eventType.includes('pipelinecreated') ||
      _eventType.includes('pipelinedeleted')
    ) {
      dispatch(
        jobsApi.util.invalidateTags([
          { type: 'Pipeline', id: 'LIST' },
          'Groups' as const,
        ]),
      );
    }

    if (_eventType.includes('pipelineupdated')) {
      dispatch(
        jobsApi.util.invalidateTags([
          { type: 'Pipeline', id: payload?.pipelineConfigurationId },
          { type: 'Pipeline', id: 'LIST' },
          'Groups' as const,
        ]),
      );
    }

    if (
      _eventType.includes('pipelineexecutioncreated') ||
      _eventType.includes('pipelineexecutiondeleted') ||
      _eventType.includes('pipelineexecutionfinished')
    ) {
      dispatch(
        jobsApi.util.invalidateTags([
          {
            type: 'Pipeline',
            id: payload?.pipelineExecution?.pipelineConfigurationId,
          },
        ]),
      );
    }

    if (
      _eventType.includes('jobs:jobfinished') &&
      BACKUP_JOBS.includes(payload?.job?.jobType)
    ) {
      const id = payload?.job?.deviceIds?.[0];
      if (id) {
        dispatch(
          devicesApi.util.invalidateTags([{ type: 'DeviceSyncStatus', id }]),
        );
      }
    }
  };

  return {
    invalidateJobTags,
  };
};
